import { MpPages } from "@mp/common/types/status.types";
import { MpIconNames } from "./common/icons/icons";

export class AppConstants {
    public static readonly LANGS = [
        { id: "es", label: "Español" },
        { id: "en", label: "English" }
    ];

    public static readonly Routing = {
        EDIT_SUFFIX: "edit",
        LOGIN: "login",
        Parts: {
            ADD: "add",
            EDIT: "edit/:id"
        }
    };

    public static readonly APP_PAGES = {
        [MpPages.LOGIN]: {
            key: MpPages.LOGIN,
            url: "/" + MpPages.LOGIN,
            icon: "log-in-outline",
            adminOnly: false
        },
        [MpPages.HOME]: {
            key: MpPages.HOME,
            url: "/" + MpPages.HOME,
            icon: MpIconNames.HOME,
            adminOnly: false
        },
        [MpPages.DASHBOARD]: {
            key: MpPages.DASHBOARD,
            url: "/" + MpPages.DASHBOARD,
            icon: MpIconNames.PLANNING,
            adminOnly: false
        },
        [MpPages.MISSIONS]: {
            key: MpPages.MISSIONS,
            url: "/" + MpPages.MISSIONS,
            icon: MpIconNames.CLIP,
            adminOnly: true
        },
        [MpPages.STAFF]: {
            key: MpPages.STAFF,
            url: "/" + MpPages.STAFF,
            icon: MpIconNames.PERSONEL,
            adminOnly: true
        },
        [MpPages.CALENDAR]: {
            key: MpPages.CALENDAR,
            url: "/" + MpPages.CALENDAR,
            icon: MpIconNames.CALENDAR,
            adminOnly: false
        },
        [MpPages.PROFILE]: {
            key: MpPages.PROFILE,
            url: "/" + MpPages.PROFILE,
            icon: "person-outline",
            adminOnly: false
        }
    };

    public static readonly MAIN_MENU = [AppConstants.APP_PAGES[MpPages.HOME], AppConstants.APP_PAGES[MpPages.DASHBOARD], AppConstants.APP_PAGES[MpPages.MISSIONS]];

    public static readonly PRIVATE_HOME = AppConstants.APP_PAGES[MpPages.DASHBOARD].url;

    public static readonly STORAGE_PREFIX = "mp:";
    public static readonly StorageKeys = {
        USER: {
            DATA: AppConstants.STORAGE_PREFIX + "user:data",
            HOME: AppConstants.STORAGE_PREFIX + "user:home",
            TEAM: AppConstants.STORAGE_PREFIX + "user:selectedTeam",
            WEEK: AppConstants.STORAGE_PREFIX + "user:selectedWeek"
        },
        STORE: {
            USER: AppConstants.STORAGE_PREFIX + "store:user",
            TEAM: AppConstants.STORAGE_PREFIX + "store:team",
            MISSION: AppConstants.STORAGE_PREFIX + "store:mission",
            SHIFT: AppConstants.STORAGE_PREFIX + "store:shift",
            CALENDAR_SHIFT: AppConstants.STORAGE_PREFIX + "store:calendarShift"
        }
    };

    public static readonly DEFAULT_LANG = AppConstants.LANGS[0].id;
    public static readonly DEFAULT_MAIN_PAGE = AppConstants.MAIN_MENU[0].url;

    public static readonly WEEKDAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
    public static readonly MONTHS = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];

    public static readonly IGNORED_USER_NAMES = ["mp01", "mp02"];
}
